import { EditQuizSummary, ThirdPartyPlatform, useProctoringHelpers, VerityInstituteSettings } from "@verity/components";
import type { CoreFileItem } from "@verity/components/core";
import {
	Application,
	Extension,
	OptionRelatedInstituteSettings,
	ProctoringAssessmentConfigurationV1,
} from "@verity/proctoring-option/types";
import styles from "./ConfigurationPanel.module.css";
import { convertProctoringAssessmentConfigurationV1ToV2 } from "@verity/proctoring-option";

export type ConfigurationProctoringOptionData = {
	applications: Application[];
	extensions: Extension[];
	thirdPartyPlatforms: ThirdPartyPlatform[];
};

type ConfigurationPanelProps = {
	proctoringData: ConfigurationProctoringOptionData;
	proctoringAssessmentConfiguration?: Partial<ProctoringAssessmentConfigurationV1>;
	verityInstituteSettings?: VerityInstituteSettings;
	optionRelatedInstituteSettings?: OptionRelatedInstituteSettings;
	referenceMaterialFiles?: CoreFileItem[];
};

export default function ConfigurationPanel({
	proctoringData,
	optionRelatedInstituteSettings,
	proctoringAssessmentConfiguration: assessmentConfigV1,
	verityInstituteSettings,
	referenceMaterialFiles,
}: ConfigurationPanelProps) {
	const v2Configuration = assessmentConfigV1
		? convertProctoringAssessmentConfigurationV1ToV2(assessmentConfigV1)
		: undefined;

	const option = v2Configuration?.proctoringOption;
	const proctoringAssessmentConfiguration = v2Configuration?.proctoringAssessmentConfiguration;
	const { allowedCategories } = useProctoringHelpers({
		verityInstituteSettings,
		optionRelatedInstituteSettings,
		proctoringOption: option,
	});

	return (
		<div className={styles.configurationTabpanel}>
			<EditQuizSummary
				applications={proctoringData.applications}
				extensions={proctoringData.extensions}
				thirdPartyPlatforms={proctoringData.thirdPartyPlatforms}
				verityInstituteSettings={verityInstituteSettings}
				optionRelatedInstituteSettings={optionRelatedInstituteSettings}
				platformOptions={{
					...option,
					isChromeOs: option?.isChromeOs || proctoringAssessmentConfiguration?.forceChromeOsManagedGuestSession,
				}}
				proctoringOption={option}
				proctoringAssessmentConfiguration={proctoringAssessmentConfiguration}
				loading={!proctoringAssessmentConfiguration}
				allowedCategories={allowedCategories}
				visibleBlocks={["thirdParty", "method", "platform", "configuration"]}
				referenceMaterialFiles={referenceMaterialFiles}
			/>
		</div>
	);
}
